var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Pack",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 24 24 24 24 0 0 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    fill: "#444444"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3633,12.6543 C7.3453,12.4963 7.3283,12.2483 7.3283,12.0173 C7.3283,11.7343 7.3453,11.5573 7.3633,11.3803 L6.0003,11.3803 L6.0003,9.8413 L7.6643,9.8413 C8.5133,7.3623 10.8143,6.0003 13.1863,6.0003 C14.4253,6.0003 15.4173,6.2653 16.2143,6.8123 L15.3993,8.4603 C14.8153,8.0353 14.0533,7.8413 13.1863,7.8413 C11.8233,7.8413 10.5313,8.4773 9.8773,9.8413 L14.7443,9.8413 L14.0013,11.3803 L9.4693,11.3803 C9.4523,11.5213 9.4343,11.7163 9.4343,12.0003 C9.4343,12.3183 9.4523,12.5303 9.4693,12.6543 L13.4693,12.6543 L12.7443,14.2123 L9.8943,14.2123 C10.5503,15.5053 11.7883,16.1233 13.1693,16.1233 C14.1603,16.1233 15.0273,15.8413 15.6293,15.2743 L16.6213,16.7973 C15.7883,17.5043 14.5853,18.0003 13.1693,18.0003 C10.7793,18.0003 8.5313,16.6553 7.6813,14.2123 L6.0003,14.2123 L6.0003,12.6543 L7.3633,12.6543 Z",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.373,0 0,5.373 0,12 C0,18.627 5.373,24 12,24 C18.627,24 24,18.627 24,12 C24,5.373 18.627,0 12,0 M12,2 C17.514,2 22,6.486 22,12 C22,17.514 17.514,22 12,22 C6.486,22 2,17.514 2,12 C2,6.486 6.486,2 12,2",
    id: "Fill-4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.e93353d3d8f342f2061afe1a5816fab3.svg";
export { ForwardRef as ReactComponent };